export default __webpack_public_path__ + "static/media/smileIcon.20ff58c7.svg";